import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';

import { IMoreButtonProps } from './MoreButton.definitions';

/** CSS import */
import Styles from './MoreButton.module.scss';

const MoreButton: React.FC<IMoreButtonProps> = ({}: IMoreButtonProps) => {
  return (
    <Link to={'/kickavenews/latest'}>
      <div className={Styles['wrapper']}>
        <p>SHOW MORE</p>
      </div>
    </Link>
  );
};

export default MoreButton;
